import { render, staticRenderFns } from "./about-news-details.vue?vue&type=template&id=6afb4992&scoped=true&"
import script from "./about-news-details.vue?vue&type=script&lang=js&"
export * from "./about-news-details.vue?vue&type=script&lang=js&"
import style0 from "./about-news-details.vue?vue&type=style&index=0&id=6afb4992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb4992",
  null
  
)

export default component.exports